var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"global-store-debug scrollbar"},[_c('h1',[_vm._v("Global Store Debug")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.jsonHTML)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }